import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/game_sessions`;

class GameSessionSeriveces {
  async getGameSessionData(activeTab, activeDate) {
    try {
      let action =
        API_ROUTE +
        `/get-game_session-list?game=${activeTab}&date=${activeDate}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.error("Errorin getGameSessionData:", error);
      throw error;
    }
  }

  async getGameSessionDelta(activeTab, activeDate, lastSyncAt) {
    try {
      let action =
        API_ROUTE +
        `/game-sessions-delta?game=${activeTab}&date=${activeDate}&since=${lastSyncAt}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.error("Errorin getGameSessionData:", error);
      throw error;
    }
  }

  ///update-session-percentage
  async updateSessionPercentage(payload) {
    try {
      let action = API_ROUTE + `/update-session-percentage-by_id`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Errorin updateMultipleSessionPercentage:", error);
      throw error;
    }
  }
  //update-multiple-session-percentage
  async updateMultipleSessionPercentage(payload) {
    try {
      let action = API_ROUTE + `/update-multiple-session-percentage`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Errorin updateMultipleSessionPercentage:", error);
      throw error;
    }
  }

  async getSessionWinningDetail(session_id) {
    try {
      const action = API_ROUTE + `/session-winning-detail/${session_id}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.error("Errorin getSessionWinningDetail:", error);
      throw error;
    }
  }
}

export default GameSessionSeriveces;
